import React, { useEffect, useState } from "react";
import useApi from "../../../CustomHooks/useApi";
import BillerInfo from "./BillerInfo";
import FetchBill from "./FetchBill";
import bharatConnectLogo from "../../../Assets/Images/bharat-connect-logo.svg";
import {
    Zap, Droplets, Flame, Car, Smartphone, Globe, Tv2, Landmark,
    Shield, GraduationCap, Building2, Bell, Phone, Users, FileText,
    CreditCard, Home, PlugZap, Ticket, TrendingUp, Gauge, Briefcase,
    Truck, ChevronRight, Search, ArrowLeft, Wifi, Radio,
} from "lucide-react";

const BbpsOnline1 = () => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [billers, setBillers] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(false);
    const [loadingBillers, setLoadingBillers] = useState(false);
    const [selectedBiller, setSelectedBiller] = useState(null);

    const [showFetchBill, setShowFetchBill] = useState(false);
    const [selectedBillerInfo, setSelectedBillerInfo] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [billerSearch, setBillerSearch] = useState("");

    const { callApi: bbpscategory } = useApi(
        "/bbps/categories",
        "GET"
    );

    const { callApi: getBillers } = useApi(
        `/bbps/billers?category=${encodeURIComponent(selectedCategory)}`,
        "GET"
    );

    // Categories
    const fetchCategories = async () => {
        try {
            setLoadingCategories(true);

            const response = await bbpscategory();

            if (response?.success) {
                setCategories(response.data || []);
            } else {
                setCategories([]);
            }
        } catch (error) {
            console.error("Category Fetch Error:", error);
            setCategories([]);
        } finally {
            setLoadingCategories(false);
        }
    };

    // Billers
    const fetchBillers = async () => {
        if (!selectedCategory) return;

        try {
            setLoadingBillers(true);

            const response = await getBillers();

            console.log("Billers Response:", response);

            if (response?.success) {
                setBillers(response.data || []);
            } else {
                setBillers([]);
            }
        } catch (error) {
            console.error("Billers Fetch Error:", error);
            setBillers([]);
        } finally {
            setLoadingBillers(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        if (selectedCategory) {
            fetchBillers();
        } else {
            setBillers([]);
        }
    }, [selectedCategory]);

    const handleCategoryChange = (e) => {
        setSelectedCategory(e.target.value);
        setSelectedBiller(null);
        setBillerSearch("");
    };

    const handleBillerSelect = (biller) => {
        console.log("Selected Biller:", biller);
        setSelectedBiller(biller);
    };


    if (showFetchBill) {
        return (
            <FetchBill
                billerInfo={selectedBillerInfo}
                selectedCategory={selectedCategory}
                onBack={() => {
                    setShowFetchBill(false);
                    setSelectedBiller(null);
                }}
            />
        );
    }

    // Show Biller Info Component
    if (selectedBiller) {
        return (
            <BillerInfo
                billerId={selectedBiller.billerId}
                billerName={selectedBiller.billerName}
                onBack={() => setSelectedBiller(null)}
                onProceed={(info) => {
                    setSelectedBillerInfo(info);
                    setShowFetchBill(true);
                }}
            />
        );
    }

    const categoryConfig = {
        "Electricity":             { Icon: Zap,          bg: "bg-yellow-50",  iconColor: "text-yellow-500", desc: "Pay Electricity Bills" },
        "Water":                   { Icon: Droplets,     bg: "bg-blue-50",    iconColor: "text-blue-500",   desc: "Pay Water Bills" },
        "Gas":                     { Icon: Flame,        bg: "bg-orange-50",  iconColor: "text-orange-500", desc: "Pay Gas Bills" },
        "LPG Gas":                 { Icon: Flame,        bg: "bg-orange-50",  iconColor: "text-orange-600", desc: "Pay LPG Gas Bills" },
        "Mobile Postpaid":         { Icon: Smartphone,   bg: "bg-green-50",   iconColor: "text-green-600",  desc: "Pay Mobile Postpaid Bills" },
        "Mobile Prepaid":          { Icon: Smartphone,   bg: "bg-emerald-50", iconColor: "text-emerald-600",desc: "Pay Mobile Prepaid Bills" },
        "Broadband Postpaid":      { Icon: Wifi,         bg: "bg-indigo-50",  iconColor: "text-indigo-600", desc: "Pay Broadband Bills" },
        "DTH":                     { Icon: Radio,        bg: "bg-purple-50",  iconColor: "text-purple-600", desc: "Pay DTH Bills" },
        "Cable TV":                { Icon: Tv2,          bg: "bg-pink-50",    iconColor: "text-pink-600",   desc: "Pay Cable TV Bills" },
        "Loan Repayment":          { Icon: Landmark,     bg: "bg-blue-50",    iconColor: "text-blue-600",   desc: "Pay your Loan Bills" },
        "Insurance":               { Icon: Shield,       bg: "bg-teal-50",    iconColor: "text-teal-600",   desc: "Pay Insurance Premium Bills" },
        "Education Fees":          { Icon: GraduationCap,bg: "bg-violet-50",  iconColor: "text-violet-600", desc: "Pay Education Fees Bills" },
        "FASTag":                  { Icon: Car,          bg: "bg-red-50",     iconColor: "text-red-500",    desc: "Pay Fastag Bills" },
        "Municipal Taxes":         { Icon: Building2,    bg: "bg-slate-50",   iconColor: "text-slate-600",  desc: "Pay Municipal Bills" },
        "Municipal Services":      { Icon: Building2,    bg: "bg-gray-50",    iconColor: "text-gray-600",   desc: "Pay Municipal Services Bills" },
        "Housing Society":         { Icon: Home,         bg: "bg-amber-50",   iconColor: "text-amber-600",  desc: "Pay Society Maintenance Bills" },
        "Subscription":            { Icon: Bell,         bg: "bg-pink-50",    iconColor: "text-pink-500",   desc: "Pay Subscription Bills" },
        "Landline Postpaid":       { Icon: Phone,        bg: "bg-sky-50",     iconColor: "text-sky-600",    desc: "Pay Landline Postpaid Bills" },
        "Clubs and Association":   { Icon: Users,        bg: "bg-indigo-50",  iconColor: "text-indigo-500", desc: "Pay Club & Association Bills" },
        "E-Challan":               { Icon: FileText,     bg: "bg-red-50",     iconColor: "text-red-600",    desc: "Pay Vehicle Challan and others" },
        "Credit Card":             { Icon: CreditCard,   bg: "bg-slate-50",   iconColor: "text-slate-600",  desc: "Pay Credit Card Bills" },
        "Rental":                  { Icon: Home,         bg: "bg-amber-50",   iconColor: "text-amber-500",  desc: "Pay Rental Bills" },
        "EV Recharge":             { Icon: PlugZap,      bg: "bg-green-50",   iconColor: "text-green-700",  desc: "Recharge your EV" },
        "NCMC Recharge":           { Icon: Ticket,       bg: "bg-cyan-50",    iconColor: "text-cyan-600",   desc: "Pay NCMC Bills" },
        "National Pension System": { Icon: TrendingUp,   bg: "bg-blue-50",    iconColor: "text-blue-700",   desc: "Pay NPS Bills" },
        "Prepaid Meter":           { Icon: Gauge,        bg: "bg-yellow-50",  iconColor: "text-yellow-600", desc: "Pay Prepaid Meter Bills" },
        "Agent Collection":        { Icon: Briefcase,    bg: "bg-gray-50",    iconColor: "text-gray-700",   desc: "Agent Collection Made Easy" },
        "Fleet Card Recharge":     { Icon: Truck,        bg: "bg-red-50",     iconColor: "text-red-500",    desc: "Recharge Your Fleet Card" },
        "Globe":                   { Icon: Globe,        bg: "bg-indigo-50",  iconColor: "text-indigo-600", desc: "Pay Bills" },
    };

    const getConfig = (cat) =>
        categoryConfig[cat] || { Icon: FileText, bg: "bg-slate-50", iconColor: "text-slate-500", desc: "Pay Bills" };

    const filteredCategories = categories.filter((cat) =>
        cat.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="min-h-screen bg-slate-50">

            {/* Page Header */}
            <div className="bg-white border-b px-6 py-4 flex items-center justify-between">
                <div>
                    <h1 className="text-xl font-bold text-slate-800">Bill Payments</h1>
                    <p className="text-xs text-slate-500 mt-0.5">Pay all your bills in one place</p>
                </div>
                <img
                    src={bharatConnectLogo}
                    alt="Bharat Connect"
                    className="h-8"
                />
            </div>

            <div className="p-6">
                {!selectedCategory ? (
                    /* ── Category Selection ── */
                    <div className="bg-white rounded-2xl shadow-sm border p-6">
                        <div className="flex items-center justify-between mb-5">
                            <h2 className="text-base font-semibold text-slate-700">Select a Service</h2>
                            <div className="relative">
                                <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                                <input
                                    type="text"
                                    placeholder="Search services..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="pl-8 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 w-52"
                                />
                            </div>
                        </div>

                        {loadingCategories ? (
                            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                                {[...Array(10)].map((_, i) => (
                                    <div key={i} className="animate-pulse bg-slate-100 rounded-xl h-24" />
                                ))}
                            </div>
                        ) : (
                            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                                {filteredCategories.map((category, index) => {
                                    const { Icon, bg, iconColor, desc } = getConfig(category);
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => {
                                                setSelectedCategory(category);
                                                setSelectedBiller(null);
                                            }}
                                            className="flex flex-col items-start gap-2 p-4 rounded-xl border border-slate-100 cursor-pointer hover:border-blue-300 hover:shadow-md transition-all group"
                                        >
                                            <div className={`w-10 h-10 rounded-xl ${bg} flex items-center justify-center`}>
                                                <Icon size={20} className={iconColor} strokeWidth={1.8} />
                                            </div>
                                            <div>
                                                <p className="text-sm font-semibold text-slate-800 leading-tight group-hover:text-blue-600">
                                                    {category}
                                                </p>
                                                <p className="text-xs text-slate-400 mt-0.5 leading-tight">
                                                    {desc}
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })}

                                {filteredCategories.length === 0 && (
                                    <div className="col-span-5 text-center py-10 text-slate-400">
                                        No services found for "{searchQuery}"
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    /* ── Billers List ── */
                    <div className="bg-white rounded-2xl shadow-sm border p-6">
                        <div className="flex items-center justify-between gap-3 mb-6">
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={() => {
                                        setSelectedCategory("");
                                        setSelectedBiller(null);
                                        setBillerSearch("");
                                    }}
                                    className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 font-medium"
                                >
                                    <ArrowLeft size={16} /> Back
                                </button>
                                <div className="flex items-center gap-2">
                                    <div className={`w-9 h-9 rounded-xl ${getConfig(selectedCategory).bg} flex items-center justify-center`}>
                                        {(() => { const { Icon, iconColor } = getConfig(selectedCategory); return <Icon size={18} className={iconColor} strokeWidth={1.8} />; })()}
                                    </div>
                                    <div>
                                        <h2 className="text-base font-bold text-slate-800">{selectedCategory}</h2>
                                        <p className="text-xs text-slate-400">Select your operator</p>
                                    </div>
                                </div>
                            </div>
                            <div className="relative">
                                <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                                <input
                                    type="text"
                                    placeholder={`Search ${selectedCategory}...`}
                                    value={billerSearch}
                                    onChange={(e) => setBillerSearch(e.target.value)}
                                    className="pl-8 pr-4 py-2 text-sm border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 w-52"
                                />
                            </div>
                        </div>

                        {loadingBillers ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {[...Array(4)].map((_, i) => (
                                    <div key={i} className="animate-pulse bg-slate-100 rounded-xl h-20" />
                                ))}
                            </div>
                        ) : billers.length > 0 ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {billers
                                    .filter((b) =>
                                        b.billerName.toLowerCase().includes(billerSearch.toLowerCase())
                                    )
                                    .map((biller) => (
                                    <div
                                        key={biller.billerId}
                                        onClick={() => handleBillerSelect(biller)}
                                        className="flex items-center justify-between border border-slate-100 rounded-xl p-4 cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all group"
                                    >
                                        <div className="flex items-center gap-3">
                                            <div className={`w-10 h-10 rounded-xl ${getConfig(selectedCategory).bg} flex items-center justify-center`}>
                                                {(() => { const { Icon, iconColor } = getConfig(selectedCategory); return <Icon size={18} className={iconColor} strokeWidth={1.8} />; })()}
                                            </div>
                                            <div>
                                                <p className="font-semibold text-sm text-slate-800 group-hover:text-blue-700">
                                                    {biller.billerName}
                                                </p>
                                                <p className="text-xs text-slate-400">
                                                    Coverage: {biller.coverage}
                                                </p>
                                            </div>
                                        </div>
                                        <ChevronRight size={18} className="text-blue-400" />
                                    </div>
                                ))}
                                {billers.filter((b) =>
                                    b.billerName.toLowerCase().includes(billerSearch.toLowerCase())
                                ).length === 0 && billerSearch && (
                                    <div className="col-span-2 text-center py-10 text-slate-400">
                                        No operators found for "{billerSearch}"
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="text-center py-10 text-slate-400">
                                No billers found for {selectedCategory}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BbpsOnline1;